import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook, Youtube, User } from "lucide-react";
import { LOGO_URL, CONTACT } from "@/data/constants";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function TopBar({ onLoginClick }) {
  const { lang, setLang } = useI18n();
  const { user, logout } = useAuth();
  return (
    <div className="hidden md:block bg-kp-teal-dark text-white text-xs">
      <div className="max-w-[1400px] mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-5">
          <span className="flex items-center gap-1.5"><MapPin size={13}/> {CONTACT.address}</span>
          <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-1.5 hover:text-white/80"><Phone size={13}/> {CONTACT.phone}</a>
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-1.5 hover:text-white/80"><Mail size={13}/> {CONTACT.email}</a>
        </div>
        <div className="flex items-center gap-5">
          <span className="hidden lg:inline text-white/70">Follow Us:</span>
          <div className="flex items-center gap-3">
            <a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-white/80" data-testid="social-instagram"><Instagram size={14}/></a>
            <a href={CONTACT.facebookUrl} target="_blank" rel="noreferrer" className="hover:text-white/80" data-testid="social-facebook"><Facebook size={14}/></a>
            <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer" className="hover:opacity-80" data-testid="social-whatsapp" aria-label="WhatsApp">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.449L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/></svg>
            </a>
          </div>
          <div className="w-24" data-testid="lang-selector">
            <Select value={lang} onValueChange={setLang}>
              <SelectTrigger className="h-7 text-xs bg-transparent border-white/20 text-white">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="en">English</SelectItem>
                <SelectItem value="gu">ગુજરાતી</SelectItem>
                <SelectItem value="hi">हिंदी</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {user ? (
            <div className="flex items-center gap-2">
              <Link to={user.role === "admin" ? "/admin" : "/dashboard"} className="flex items-center gap-1.5 hover:text-white/80" data-testid="topbar-dashboard"><User size={13}/> {user.name}</Link>
              <button onClick={logout} className="text-white/70 hover:text-white" data-testid="topbar-logout">Logout</button>
            </div>
          ) : (
            <button onClick={onLoginClick} className="flex items-center gap-1.5 hover:text-white/80" data-testid="topbar-login"><User size={13}/> Login / Register</button>
          )}
        </div>
      </div>
    </div>
  );
}
